import { Button } from '@mui/material';
import { IconFilter, IconRepeat, IconMapPin } from '@tabler/icons-react';
import { useFiltersContext } from './hooks/useFiltersContext';
import PDFGeneratorButton from './PDF/PDFGeneratorButton';
import { getUserSession } from '../../../../util/core/Session';
import config from '../../../../config/config';

export const Buttons = ({ onClickFilters, onClickCityFilter }) => {
    const { resetFilters, filters } = useFiltersContext();
    const session = getUserSession();

    const profile = session.user.application_profile_id;

    const isAdm = profile === config.default_foreign_key.profiles.zellusAdmin;

    const isClientManager =
        profile === config.default_foreign_key.sdg_profiles.clientManager;

    return (
        <div className="d-flex" style={{ gap: '8px' }}>
            <Button
                onClick={onClickFilters}
                variant="outlined"
                startIcon={<IconFilter size={20} />}
                style={{
                    height: '40px',
                    borderRadius: '8px',
                    borderColor: '#E9EAEB',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '14px',
                    padding: '0 16px',
                    color: '#252B37'
                }}
                sx={{
                    '&:hover': {
                        backgroundColor: '#fff',
                        borderColor: '#E9EAEB',
                        boxShadow: 'none'
                    }
                }}
            >
                Filtros
            </Button>
            <Button
                onClick={onClickCityFilter}
                variant="outlined"
                startIcon={<IconMapPin size={20} />}
                style={{
                    height: '40px',
                    borderRadius: '8px',
                    borderColor: '#E9EAEB',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '14px',
                    padding: '0 16px',
                    color: '#252B37'
                }}
                sx={{
                    '&:hover': {
                        backgroundColor: '#fff',
                        borderColor: '#E9EAEB',
                        boxShadow: 'none'
                    }
                }}
            >
                {filters.cidade?.label}
            </Button>
            <Button
                onClick={resetFilters}
                variant="outlined"
                style={{
                    height: '40px',
                    borderRadius: '8px',
                    borderColor: '#E9EAEB',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '14px',
                    padding: '0 16px',
                    color: '#252B37'
                }}
                sx={{
                    '&:hover': {
                        backgroundColor: '#fff',
                        borderColor: '#E9EAEB',
                        boxShadow: 'none'
                    }
                }}
            >
                <IconRepeat size={20} />
            </Button>

            <PDFGeneratorButton className={'pdf-button-dashboards'} />
        </div>
    );
};
